import { render, staticRenderFns } from "./ListaStatusCard.vue?vue&type=template&id=4d08d4b7"
import script from "./ListaStatusCard.vue?vue&type=script&lang=js"
export * from "./ListaStatusCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports